require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-instructor-picks-gift-ideas-for-the-developer-in-your-life.json") })
        }
      }, "path---blog-instructor-picks-gift-ideas-for-the-developer-in-your-life");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-instructor-picks-gift-ideas-for-the-developer-in-your-life!./.cache/json/blog-instructor-picks-gift-ideas-for-the-developer-in-your-life.json
// module id = 879
// module chunks = 231608221292675